export default __webpack_public_path__ + "13d83b44a7dd82ae7ba6bf468e37f824.png";